import { TFunction } from 'i18next';
import { Dispatch, SetStateAction } from 'react';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath, APIPathWithArguments } from 'src/js/api/route-path-index';
import { notificationHandler } from 'src/js/notification/notification-handler';
import { createWatchStore, updateWatchStore } from 'src/js/store/use-watch';

import { GetAllScteResponse, ScteResponse, ScteViewModel, mapScteResponse, mapScteViewModel } from './scte-models';

const scteModels: ScteViewModel[] = [];
createWatchStore(scteModels);
export default scteModels;

export const saveResponseToScte = (response: ScteViewModel[]) => {
  updateWatchStore(scteModels, response);
};

const replaceViewModel = (response: ScteResponse, t: TFunction, selected = false) => {
  const viewModel = mapScteViewModel(response, t);
  const scte = [...scteModels];
  const index = scte.findIndex((e) => e.id === viewModel.id);
  if (index > -1) {
    scte.splice(index, 1, { ...viewModel, selected: selected });
  }

  saveResponseToScte(scte);
};

export const fetchScte = (t: TFunction) => {
  return apiClientWithoutHandler.genericController.get<GetAllScteResponse>(APIPath.scte.list).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        const viewModels = mapScteResponse(response, t);
        saveResponseToScte(viewModels);
      }
    }
    return res;
  });
};

export const startStopScte = (model: ScteViewModel, start: boolean, selected: boolean, t: TFunction) => {
  const path = APIPathWithArguments(start ? APIPath.scte.start : APIPath.scte.stop, {
    id: model.id,
  });
  return apiClientWithoutHandler.genericController
    .put<ScteResponse>(path)
    .then((res) => {
      if (res.ok) {
        const response = res.data;
        if (response) {
          replaceViewModel(response, t, selected);
        }
      }
      return res;
    })
    .then((res) => {
      notificationHandler(res, null, null, t);
      return res;
    });
};

export const fetchScteStatistics = (
  model: ScteViewModel,
  t: TFunction,
  setStatistics: Dispatch<SetStateAction<ScteViewModel>>,
) => {
  const path = APIPathWithArguments(APIPath.scte.stats, { id: model.id });
  return apiClientWithoutHandler.genericController.get<ScteResponse>(path).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        setStatistics(mapScteViewModel(response, t));
      }
    }
    return res;
  });
};

export const resetScteStatistics = (
  model: ScteViewModel,
  t: TFunction,
  setStatistics: Dispatch<SetStateAction<ScteViewModel>>,
) => {
  const path = APIPathWithArguments(APIPath.scte.stats, { id: model.id });
  return apiClientWithoutHandler.genericController.delete<ScteResponse>(path).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        setStatistics(mapScteViewModel(response, t));
      }
    }
    return res;
  });
};

export const updateScte = (model: ScteViewModel, t: TFunction) => {
  const path = APIPathWithArguments(APIPath.scte.update, { id: model.id });
  return apiClientWithoutHandler.genericController
    .put<ScteResponse>(path, model)
    .then((res) => {
      if (res.ok) {
        const response = res.data;
        if (response) {
          replaceViewModel(response, t);
        }
      }
      return res;
    })
    .then((res) => {
      notificationHandler(
        res,
        t('scte.notifications.settingsChangeSuccessMsg'),
        t('scte.notifications.settingsChangeErrorMsg'),
        t,
      );
      return res;
    });
};
